/* eslint-disable react/display-name */
import clsx from "clsx";
import React, {
  ForwardRefExoticComponent,
  InputHTMLAttributes,
  RefAttributes,
  forwardRef,
} from "react";
import { useTranslation } from "react-i18next";

interface TextareaFactoryOptions
  extends InputHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  rows?: number;
}

export interface TextareaProps extends TextareaFactoryOptions {
  "aria-label": string;
  busy?: boolean;
}

export const createTextarea = ({
  className: configClassName,
  ...config
}: TextareaFactoryOptions): ForwardRefExoticComponent<
  TextareaProps & RefAttributes<HTMLTextAreaElement>
> =>
  forwardRef<HTMLTextAreaElement, TextareaProps>(
    (
      {
        "aria-label": ariaLabel,
        busy,
        className = configClassName,
        disabled,
        ...rest
      },
      ref
    ) => {
      const { t } = useTranslation();
      return (
        <textarea
          {...config}
          {...rest}
          className={clsx(
            "tw-textarea",
            disabled && "tw-textarea--disabled",
            busy && "tw-textarea--busy",
            configClassName,
            className
          )}
          aria-label={t(`aoda.inputLabel.${ariaLabel}`)}
          disabled={disabled}
          ref={ref}
        />
      );
    }
  );
